import { useActions } from "@hooks/useActions";
import { useTypedSelector } from "@hooks/useTypedSelector";
import { useEffect } from "react";
import { isToday } from "date-fns";

export default () => {
	const { fetchVehiclesStatuses, fetchVehiclesTypes } = useActions()
	const { selectedDate } = useTypedSelector(state => state.selectedDate)

	useEffect(() => {
		const fetchDataByVariant = (variant: 'types' | 'statuses') => {
			const fetchCb = variant === 'types' ? fetchVehiclesTypes : fetchVehiclesStatuses
			if (selectedDate) {
				fetchCb({
					tzOffset: new Date().getTimezoneOffset(),
					// в прошлом и будущем отправляем выбранную дату, если в пикере выбран сегодняшний день, то время, которое сейчас
					targetTime: (isToday(selectedDate) ? new Date() : selectedDate).getTime()
				})
			}
		}

		fetchDataByVariant('types')
		fetchDataByVariant('statuses')

		const typesId = setInterval(() => fetchDataByVariant('types'), 1000 * 60 * 5)
		const statusesId = setInterval(() => fetchDataByVariant('statuses'), 1000 * 60 * 5)

		return () => {
			clearInterval(typesId)
			clearInterval(statusesId)
		}
	}, [selectedDate]);
}